import items from '@/helpers/map_menu/items';

const loadMapMenuItems = async () => {
    return {data: items};
};

export {
    loadMapMenuItems,
}